import {
    observable,
    action,
    //computed
} from 'mobx'
import axios from "axios";
import intl from 'react-intl-universal';
import {convertApis, Task, foxitSignApi} from 'Api/index'
import {convertService, userBehaviorTrackingService, TASK_MAP} from './services/index'
import { TASK_STATUS, /*isToPDF,*/ CONVERT_TYPE, DEFAULT_FILE_NAME } from "Api/constants";
import {store} from './store.index';
import { getExtensionByFileName } from '@/utils/utils';

/**
 * task list
 * task status
 * 
 */
class TaskStore {
  @observable htmlFileName = ''
  @observable isSetTimeOutId = null
  @observable fileDataList = []
  @observable tasksFinishCallback = null
  /** @type {Task[]} */
  @observable tasks = [];
  /** @type {Task[]} */
  @observable tasksUploaded = [];
  /**@type {Number} */
  @observable hasTask = false;
  @observable convertTaskId = null;
  @observable taskMessage = null;
  /** @type {Task} */
  @observable.ref currentTask = null;
  @observable isUploading = false;

  // be called after request server-config
  @action initialize() {
    convertApis.initialize();
  }
  @action updateTasksFinishCallback = (value) => {
    this.tasksFinishCallback = value
  }
  @action setHasTask(value){
    this.hasTask = value;
  }

  @action isContinueToConvert(taskId){
    return this.hasTask && this.convertTaskId === taskId;
  }
  @action doCancelCurrentTask(){
    this.hasTask = false;
    // this.tasks = [];
    // this.tasksUploaded = [];
    this.convertTaskId = null;
    this.taskMessage = null;
    if(this.currentTask){
      this.currentTask.cancel('stop');
    }
    if(this._lastHandle){
      clearInterval(this._lastHandle);
      this._lastHandle = null;
    }
  }
  @action doCleanTaskFileList(){
    this.hasTask = false;
    this.tasks = [];
    this.tasksUploaded = [];
    this.convertTaskId = null;
    if(this.currentTask){
      this.currentTask.cancel('stop');
    }
  }
  /**
   *
   *
   * @param {Object|null} msg
   * @param {string} msg.title
   * @param {string} msg.info
   * @param {string} msg.addition
   * @param {Object} msg.infoParam
   * @param {string} msg.type: icon type
   * @param {Boolean} msg.failed
   * @param {string} msg.progress
   * @param {Number} timeAfterClean
   */
  @action setTaskMessage(msg, timeAfterClean, cleanProgress) {
    const {hasSignIn, allowNoSignIn} = store.userStore;
    if(!hasSignIn && !allowNoSignIn){
      this.doCancelCurrentTask();
      //return;
    }
    
    this.taskMessage = msg;
    if(timeAfterClean !== void 0 && timeAfterClean >= 0){
        this.CleanMessageAfterTime(timeAfterClean);
    }
    if(cleanProgress && this._lastHandle){
      clearInterval(this._lastHandle);
      this._lastHandle = null;
    }
  }


  CleanMessageAfterTime(timeAfterClean){
    if(!timeAfterClean){
      timeAfterClean = 0;
    }
    let handle = setTimeout(()=>{
      clearInterval(handle);
      this.taskMessage = null;
    },timeAfterClean);
  }
  _lastHandle = null;
  /**
   *
   * @param {Object} msg
   * @param {string} msg.title
   * @param {string} msg.info
   * @param {string?} msg.addition
   * @param {Boolean} msg.failed
   * @param {Number} msg.startProgress
   * @param {Number} msg.endProgress
   * @param {Number} msg.interval
   * @param {Number} msg.times
   */
  @action setTaskMessageWithProgressByTime(msg){
    if(this._lastHandle){
      clearInterval(this._lastHandle);
      this._lastHandle = null;
    }
    const {startProgress, endProgress, interval = 2000, times = 30} = msg;
    let count = 0;
    let currentProgress = startProgress;
    let newMsg = {...msg};
    newMsg.progress = currentProgress;
    this.setTaskMessage(newMsg);
    let handle = setInterval(()=>{
      count++;
      if(!handle||!this._lastHandle){
        return;
      }
      if(count>times|| !this.taskMessage){
        clearInterval(handle);
        handle = null;
        this._lastHandle = null;
        return;
      }
      currentProgress = startProgress + (endProgress-startProgress) * count / times;
      newMsg.progress = currentProgress;
      this.setTaskMessage(newMsg);
    }, interval);
    this._lastHandle = handle;
  }

  inner_callback = (result, callback) =>{
    if(!this.hasTask){
      return;
    }
    if(result.status === TASK_STATUS.FINISH){
      this.hasTask = false;
    }else if(result.status === TASK_STATUS.MINOTOR){
      ////"{"ret":0,"msg":"SUCCESS","data":{"taskid":"9c748722-cea8-4d0d-8018-9f14dd76b108"}}"
      const {taskid} = result.data;
      this.convertTaskId = taskid;
    }
    callback && callback(result);
  }
  inner_error = (result, errorCallback,data) =>{
    if(!this.hasTask){
      return;
    }
    this.hasTask = false;
    store.appStore.doPostError({
      level:'warn',
      category:'platformApi',
      data:{result,data}
    })
    errorCallback && errorCallback(result);
  }
  //对html2pdf的timepout字段进行操作
  @action timeOutOption(cfg,error){
    if(cfg&&cfg.confText){
        if(this.isSetTimeOutId){
          clearTimeout(this.isSetTimeOutId);
        }
        let setting=JSON.parse(cfg.confText);
        let time=setting.timeout;
        this.isSetTimeOutId=setTimeout(()=>{
          //判断转换任务还是否存在，存在则抛出error中断task任务
          if(this.hasTask){
            store.taskStore.doCancelCurrentTask();
            error && error("time out");
          };
        },time*1000)
    }
  }
  @action convertUrlToPDFNoProgress(type, cfg, callback, error){
      //对html2pdf的timepout字段进行操作
    this.timeOutOption(cfg,error);
    let _this=this;
    convertService.doConvert( [], type, cfg, async (result) => {
      _this.isUploading = false;
        if (result.ret != 0) { 
          error && error(result);
          return;
        }
        _this.convertTaskId = result.data.taskid;
        callback && callback(result);
      }, (err) => {
        _this.isUploading = false;
        error && error(err);
      },
    );
  }
  @action convertUrlToPDF(type, cfg, callback, error){
      //对html2pdf的timepout字段进行操作
    this.timeOutOption(cfg,error);
    // if(!this.hasTask){
    //   return;
    // }
    let taskConvert = this.createConvertTask( [], type, cfg, (result) => {
        if(result.status !== TASK_STATUS.MINOTOR){
          result.status = TASK_STATUS.FINISH;
        }
        this.inner_callback(result, callback);
        // 'onUpdateTaskMessage' must be called after 'inner_callback'
        this.onUpdateTaskMessage(result, type);
      }, (err) => {
        err.status = err.ret === 1?TASK_STATUS.CANCEL: TASK_STATUS.ERROR;
        this.onUpdateTaskMessage(err, type);
        let data = {
          type, cfg
        }
        this.inner_error(err, error,data);
      },
    );
    taskConvert.start();
  }
  /**
   *
   *
   * @param {FileData} fileData
   * @param {Number} type
   * @param {Object} cfg
   * @param {Function} callback
   * @memberof TaskStore
   */
  @action convertFile(fileData, type, cfg, callback, error,showSpin=true) {
    // 覆盖online的转换
    console.log("fwconverFile");
    store.convert.openFileBeforeConvert(fileData.file, fileData.fileName);
    return
    if(!this.hasTask){
      return;
    }
    // begin => onFinishUpload
    const onFinishUpload = (result)=>{
      const { docid } = result.data;
      const fileInfo = { docid, password: fileData.password };
      
      const {pageRange, selectRect, docPageCount, destFilename, ...otherCfg} = cfg || {};
      if (selectRect) {
        fileInfo.selectRect = selectRect;
      } else if (pageRange) {
        fileInfo.docPageCount = docPageCount;
        fileInfo.pageRange = pageRange;
      }
      if (destFilename) {
        fileInfo.destFilename = destFilename;
        fileInfo.src_pdf_path = destFilename;
      }
      
      // ! 调用doc/convert接口 获取 taskid
      let taskConvert = this.createConvertTask([fileInfo], type, otherCfg, async (result) => {
          if (result.status !== TASK_STATUS.MINOTOR) {
            result.status = TASK_STATUS.FINISH;
          }
          this.inner_callback(result, callback);
          showSpin && this.onUpdateTaskMessage(result, type);
        }, (err) => {
          err.status = err.ret === 1 ? TASK_STATUS.CANCEL : TASK_STATUS.ERROR;
          showSpin && this.onUpdateTaskMessage(err, type);
          let data = {
            fileName: fileData.fileName,
            type,
            otherCfg
          };
          this.inner_error(err, error, data);
        },
      );
      taskConvert.start();
    }
    // end => onFinishUpload
    this.isUploading = false;
    let taskUpload = this.createUploadTask( fileData, type, (result) => {
      if(result=='stop'){
        callback(result);
        return 
      }
        if(!this.hasTask){
          return;
        }
        
        taskUpload.onMessage({type:TASK_STATUS.UPLOADED, percent:100 })
        result.status = TASK_STATUS.CONVERT;
        result.fileName = fileData.fileName;
        showSpin&&this.onUpdateTaskMessage(result, type);
        this.inner_callback(result, callback);
        // do next
        onFinishUpload(result);
      }, (err) => {
        if(!this.hasTask){
          return;
        }
        err.status = TASK_STATUS.ERROR;
        showSpin&&this.onUpdateTaskMessage(err, type);
        let data = {
          fileData,
          type
        }
        this.inner_error(err, error,data);
      }, ({percent, /* task */})=>{
        if(percent === 0){
          //this.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, type);
        }
        taskUpload.onMessage({type:TASK_STATUS.ON_UPLOADING, percent})
      }
    );
    //taskUpload.start();
    //
    this.doAddToTaskList(taskUpload);
  }

  /**
   * @param {FileData[]} fileList
   * @returns {Task[]}
   * @memberof TaskStore
   */
  @action doUploadMultiFiles(fileList, error){
    let isLargeFile = false;
    fileList.forEach((fileData)=>{
      // const  {file, /* dataType */} = fileData;
      if(fileData.getSize() >= 1024 * 1024 * 1024){
        isLargeFile = true;
      }
    })
    if(isLargeFile){
      error && error({ret :1, msg :'Error.FileLimit', list:[]});
      const msg = intl.get('Error.FileLimit',{FileLimit:'1G'});
      store.appStore.setGlobalMessage({type: 'error', content: msg});
      //this.setTaskMessage({ title: '', info: 'Error.FileLimit', infoParam:{FileLimit: '1G'}, type: 'error'}, 6000)
      return [];
    }

    this.setHasTask(true);
    let list = []
    fileList.forEach((fileData) => {
      let fileUid = fileData.index;
      let fileName = fileData.fileName;
      let taskUpload = this.createUploadTask(fileData, -1, (result) => {
        if (!this.hasTask||!result.data) {
          return;
        }

        const { docid } = result.data;
        taskUpload.onMessage({type:TASK_STATUS.UPLOADED, percent:100, docid})
        result.status = TASK_STATUS.CONVERT;
        // finish upload, clean data
        //taskUpload.clearData();
        this.tasksUploaded.push(taskUpload);
      }, (err) => {
        if (!this.hasTask) {
          return;
        }
        err.status = TASK_STATUS.ERROR;
        //this.onUpdateTaskMessage(err);
        //inner_error(err);
        error && error({ret :1, msg :'Error.UploadingFile.fail', list:[{id:fileUid,taskId:taskUpload.id, fileName}]});
      }, ({ percent }) => {
        taskUpload.onMessage({type:TASK_STATUS.ON_UPLOADING, percent })
      });
      this.doAddToTaskList(taskUpload, true);
      list.push({id:fileUid,taskId:taskUpload.id, task:taskUpload});
    });
    error && error(list);
    return list;
  }

  @action createToPDFTasksByCombineFiles(seqList, cfg){
    let hasConvert =false;
    seqList.forEach((taskId)=>{
      let fileInfo = this.getDocInfoByTaskId(taskId.taskId||taskId);
      if(!fileInfo)return;
      const {docid, fileName} = fileInfo;
      // 
      if(getExtensionByFileName(fileName) === '.pdf'){
        return;
      }
      let type = this.getTaskTypeByFileName(fileName)
      let task = this.createConvertTask([{docid}],type, cfg, (result)=>{
        if(result.status === TASK_STATUS.MINOTOR){
          ////"{"ret":0,"msg":"SUCCESS","data":{"taskid":"9c748722-cea8-4d0d-8018-9f14dd76b108"}}"
          const {taskid} = result.data;
          this.convertTaskId = taskid;
        }
        if(!result.data.docid){
          return;
        }
        if(result.data.docid !== docid){
          this.updateDocInfoByTaskId(taskId, result.data.docid);
        }
        // do next
        this.doNextTask();
      }, (/* error */)=>{
        // show error, remove file
        this.clearDocInfoByTaskId(taskId);
        // do next
        this.doNextTask();
      })
      this.doAddToTaskList(task);
      hasConvert = true
    })

    return hasConvert;
  }
  //显示下载压缩包窗口弹窗
  @action doDownloadMultifiles(seqList, callback,error){
    //如果都是执行转换失败，抛出错误，不出现下载弹窗
    let seqListNoId=seqList.filter((item)=>{return !item.id})
    if(seqListNoId.length==seqList.length){
      error && error("error");
      return
    }
    this.fileDataList=seqList;
    this.onUpdateTaskMessage({ status: TASK_STATUS.FINISH,url:"formSubmit",fileName:"" }, -1);
    callback && callback("ok");
  }

  //点击下载时候如果为post表单提交触发该方法
  @action doDownloadFn(){
    convertService.doDownloadMultiFile(this.fileDataList);
  }
  @action doGetConvertedFileZipPackageBlob() {
    return convertService.doDownloadMultiFile(this.fileDataList, true);
  }
  /**
     *
     *
     * @param {Number[]} seqList The id of task
     * @param {Function} callback
     */
    @action doCombineMultifiles(seqList, cfg, callback, error){
      let _this = this;
      let task = new Task({ seqList, cfg, callback, error }, async ({ seqList, cfg, callback, error }) => {
        // foreach add convert task for text => pdf
        _this.isUploading = false;
        //
        let hasConvert =false;
        hasConvert = this.createToPDFTasksByCombineFiles(seqList, cfg);
        
  
        const fn = ()=>{
          _this.isUploading = false;
          let list = this.doGetDocIdList(seqList);
          this.doConvertMultiFiles(list, CONVERT_TYPE.MERGEPDF, cfg, (result)=>{
              if(result.status !== TASK_STATUS.FINISH)return;
              if(result.data.failedDocids){
                let names = result.data.failedDocids.split(',')
                let list = _this.getFileNameList(names);
                result.data.fileNames = list;
              }
              callback && callback(result);
            }, (err) => {
              error && error(err)
            }
          )
        }
  
        if(!hasConvert){
         return fn();
        } 
        //_this.currentTask = null;
        
        let task2 = new Task({}, fn);
        this.doAddToTaskList(task2);
        // 
      });
      task.setCancelSource({cancel:callback})
      this.doAddToTaskList(task);
    }
  /**
   * @param {Number[]} seqList
   * @memberof TaskStore
   */
  @action doRemoveFromMultiFiles(seqList){
    let list =null;
    // let isDoing = false;
    let id = null;
    seqList.forEach((taskId)=>{
      do{
        list = this.remove(taskId, this.tasks);
        if(list){
          break;
        }
        list = this.remove(taskId, this.tasksUploaded);
        if(list){
          break;
        }
        if(this.currentTask && taskId === this.currentTask.id){
          id = taskId;
        }
      }while(false)
    })

    if(this.currentTask && id === this.currentTask.id){
      this.currentTask.cancel('remove');
    }
  }

  getDocInfoByTaskId = (taskId)=>{
    let task = this.tasksUploaded.find((item)=>{
      return item.id === taskId;
    });
    if(!task)return null;
    const {fileData} = task.data;
    const {fileName, password} = fileData;
    let docid = task.docid;
    return {docid, password, fileName};
  }
  updateDocInfoByTaskId = (taskId, docId)=>{
    let realTaskId = taskId;
    if(typeof taskId === 'object' && 'taskId' in taskId){
      realTaskId = taskId.taskId;
    }
    let task = this.tasksUploaded.find(item=> item.id === realTaskId);
    if(!task)return null;
    let docid = task.docid;
    if(docid !== docId){
      task.docid = docId;
    }
    return task
  }
  clearDocInfoByTaskId = (taskId)=>{
    this.tasksUploaded.forEach((item,index)=>{
      if(item.id === taskId){
        this.tasksUploaded.splice(index,1)  
      }
    })
  }
  /**
   *
   *
   * @param {String[]} docidList
   */
  getFileNameList = (docidList) =>{
    let list = []
    docidList.forEach((docid)=>{
      let task = this.tasksUploaded.find((item)=>{
        return item.docid === docid;
      });
      if(!task)return;
      const {fileData} = task.data;
      const {fileName} = fileData;
      list.push(fileName)
    })
    return list;
  }
  /**
   *
   *
   * @param {Number[]} taskIdList
   * @memberof TaskStore
   */
  @action doGetDocIdList(taskIdList){
    let list = [];
    taskIdList.forEach((item)=>{
      let fileInfo = this.getDocInfoByTaskId(item.taskId);
      if(!fileInfo)return;
      list.push({ ...fileInfo, ...item });
    })
    return list;
  }
  /**
   *
   *
   * @param {String[]} seqList
   * @memberof TaskStore
   */
  @action doConvertMultiFiles(seqList, type, cfg, callback, error){
    console.log("doconvertMul")
    // let fileList = seqList.map(({docid, password})=>{
    //   let fileInfo = { docid, password };
    //   return fileInfo
    // })
    let taskConvert = this.createConvertTask( seqList, type, cfg, (result) => {
        if(result.status !== TASK_STATUS.MINOTOR){
          result.status = TASK_STATUS.FINISH;
        }
        this.inner_callback(result, callback);
        // 'onUpdateTaskMessage' must be called after 'inner_callback'
        this.onUpdateTaskMessage(result, type);
      }, (err) => {
        err.status = err.ret === 1?TASK_STATUS.CANCEL: TASK_STATUS.ERROR;
        this.onUpdateTaskMessage(err, type);
        let data = {
          seqList,
          type,
          cfg
        }
        this.inner_error(err, error, data);
      },
    );
    taskConvert.start();
  }

  @action doImportCommentTask(cfg, callback, error) {
    let { PDFFileData, wordFileData, comment_type } = cfg;
    let getUploadIdtask = (file) => {
      const result = convertService.doUpload(file);
      return result;
    }
    let fileList = [PDFFileData, wordFileData]
    //获取到两个文件上传id后
    Promise.all([getUploadIdtask(PDFFileData), getUploadIdtask(wordFileData)]).then(uploadIdList => {
      uploadIdList.map((item, index) => {
        if (item && item.ret == 0) {
          fileList[index].docid = item.data.docid;
        }

      })
      this.onUpdateTaskMessage({ status: TASK_STATUS.COMBINE, ret: 0 }, CONVERT_TYPE.COMMENT_COMBINE);
      let settings = { confText: JSON.stringify({ comment_type: comment_type }) }
      this.doCombineComment(fileList, settings, (result) => {
        callback && callback(result);
      }, (errors) => {
        //console.log(errors)
        error && error(errors)
      })
    })
  }
  //ONLINERD-7180 当前单子暂停，因服务端暂时无法实现，屏蔽入口，方法保留
  @action doCombineComment(fileList, cfg, callback, error) {
    let task = new Task({ fileList, cfg, callback, error }, async ({ fileList, cfg, callback, error }) => {
      const fn = () => {
        this.doConvertMultiFiles(fileList, CONVERT_TYPE.COMMENT_COMBINE, cfg, (result) => {
          callback && callback(result);
        }, (err) => {
          error && error(err)
        }
        )
      }
      let task2 = new Task({}, fn);
      this.doAddToTaskList(task2);
    });
    task.setCancelSource({ cancel: callback })
    this.doAddToTaskList(task);
  }

  onUpdateTaskMessage(result, type){
    const {status, startProgress, endProgress, interval, times} = result;
    let { url, fileName, blob } = result;
    let taskMap, msg;
    if(type === CONVERT_TYPE.PDFHEADERFOOTER) taskMap = TASK_MAP[type];
    else taskMap = TASK_MAP['COMMON']

    switch (status) {
      case TASK_STATUS.BEGIN_UPLOAD:
      case TASK_STATUS.UPLOADED:
      case TASK_STATUS.CONVERT:
      case TASK_STATUS.COMBINE:
      case TASK_STATUS.DOWNLOAD_FILE:
        const task = Object.assign({}, taskMap[status]);
        if (fileName) task.addition = ` ${fileName}`;
        if (startProgress) task.startProgress = startProgress;
        if (endProgress) task.endProgress = endProgress;
        if (interval) task.interval = interval;
        if (times) task.times = times;
        this.setTaskMessageWithProgressByTime(task);
        break;
      case TASK_STATUS.FINISH:
      case TASK_STATUS.DOWNLOAD_FILE_SUCCESS:
        if(!fileName){
          fileName = DEFAULT_FILE_NAME[type]
        }
        //filename:'stream'
        //新增字段标识，点击下载时候执行表单提交
        if (blob) {
          msg = { ...taskMap[status], blob };
        } else if(url==="formSubmit"){
          msg = {...taskMap[status],url}
        }else{
          let fileUrl = fileName? url.replace('filename=stream', 'filename='+ encodeURIComponent(fileName) ):url;
          msg = {...taskMap[status], url:fileUrl}
        }
        this.setTaskMessage(msg, void 0, true)
        break;
      case TASK_STATUS.ERROR:{
        msg = taskMap[status];
          let errCode = result.ret + '';
          if(result.ret === 900003) errCode = '87000005';
          if(errCode.indexOf('8') === 0){
            msg.title = 'Error.' +errCode;
          }
          this.setTaskMessage(msg, void 0, true)//, info:"Converting.info"
          break;
      }
      case TASK_STATUS.CANCEL:{
        this.setTaskMessage(null, void 0, true);
        break;
      }
      case TASK_STATUS.BEGIN_BY_GSDK:
      case TASK_STATUS.BEGIN_BY_GSDK_EXPORT_IMAGES:
      case TASK_STATUS.DOING_BY_GSDK:
      case TASK_STATUS.DOING_BY_GSDK_EXPORT_IMAGES: {
        const { progress = 0, cancelHandler } = result;
        this.setTaskMessage({...taskMap[status], progress, cancelHandler});
        break;
      }
      case TASK_STATUS.FINISH_BY_GSDK:
      case TASK_STATUS.FINISH_BY_GSDK_EXPORT_IMAGES: {
        const { progress = 100, blob, downloadName } = result;
        this.setTaskMessage({...taskMap[status], progress, blob, downloadName});
        break;
      }
      case TASK_STATUS.ERROR_BY_GSDK:
      case TASK_STATUS.ERROR_BY_GSDK_EXPORT_IMAGES: {
        const { info } = result;
        this.setTaskMessage({...taskMap[status], info});
        break;
      }
      default:
          break;
    }
    // send ga event
    if (status === TASK_STATUS.BEGIN_UPLOAD || status === TASK_STATUS.COMBINE || 
        status === TASK_STATUS.FINISH || status === TASK_STATUS.ERROR||status === TASK_STATUS.CANCEL) {
      userBehaviorTrackingService.doSendGAEventByRequest(type, status);
      return;
    }
  }

  @action createDriveFileProgress({loaded, type}) {
    switch (type) {
      case 'update':
        this.setTaskMessage({ title: 'UpdatingFile', info: 'UpdatingFile.info', type: 'in-doing', failed: false, progress: loaded });
        break;
      case 'create':
        this.setTaskMessage({ title: 'UploadingFile', info: 'UploadingFile.info', type: 'in-doing', failed: false, progress: loaded });
        break;
      default:
        break;
    }

    if (loaded === 100) {
      this.CleanMessageAfterTime(3000);
    }
  }
  @action createEnvelopeForFoxitSign = () => {
    this.doNextTask()
  }
  @action addUploadTaskForFoxitSign = ({fileList, updateProgress, uploadFailCallback}) => {
    // let percent = 0
    let list = []

    // this.setHasTask(true)
    fileList.forEach((fileData) => {
      const fileUid = fileData.index;
      const fileName = fileData.fileName
      const fileSize = fileData.getSize();
      const modified = fileData.modified
      const taskUpload = this.createUploadTaskForFoxitSign({fileData, updateProgress, uploadFailCallback})

      const fileItem = {
        file: fileData.file,
        id: fileUid,
        name: fileName,
        size: fileSize,
        modified,
        taskId: taskUpload.id,
      }

      this.addToTaskList(taskUpload)
      list.push(fileItem)
      // list.push({id: fileUid, name: fileName, size: fileSize, modified, taskId: taskUpload.id})
    })
    
    return list
  }
  @action readAsDataURL(file) {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    return new Promise((resolve) => {
      reader.onload = function () {
        resolve(reader.result);
      };
      
    })
  }
  @action createUploadTaskForFoxitSign = ({fileData, updateProgress, uploadFailCallback}) => {
    let task = new Task({ fileData }, async (data) => {
      let errorFlag = false
      const { fileData } = data;
      const fileId = fileData.index
      const fileName = fileData.fileName;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

      this.currentTask = task;
      updateProgress && updateProgress({ percent: 0, fileId});

      const fileDataBase64 = await this.readAsDataURL(fileData.file).catch((error) => {
        return error
      })
      const result = await foxitSignApi.addDocumentToEnvelope({
        fileData: fileDataBase64.split(',')[1],
        fileName,
        fileExtension,
        fileId,
        updateProgress: ({percent, fileId}) => {
          updateProgress && updateProgress({percent, fileId})
        },
        updateCancelSource: (source) => {
          task.setCancelSource(source);
        },
      }).catch((error) => {
        if (error && error.message !== 'stop') {
          errorFlag = true
        }
        return error
      })

      this.currentTask = null;
      this.isUploading = false

      if ((result && result.ret === 10000) || errorFlag) {
        uploadFailCallback && uploadFailCallback()
        this.updateTasksFinishCallback(null)
        store.userStore.updateFoxitSignEnvelopeInfo(null)
        store.taskStore.doCleanTaskFileList();
        store.appStore.showMessageDlgEx({ message: 'FoxitSign.RequestSignature.AddFiles.uploadFail' }, true, () => {});
        return
      }
      if (result && result.result && result.result.preparedEnvelopeID) {
        store.userStore.updateFoxitSignEnvelopeInfo(result.result)
        this.doNextTask()

        return
      }

      this.doNextTask()

      if(axios.isCancel(result)){
        console['log']("TCL: @actioncreateUploadTask -> cancel this.currentTask, result", task, result)
        return;
      }
    });
    
    return task
  }

  /**
   * @param {FileData} fileData
   * @returns {Task} A task for upload file
   * @memberof TaskStore
   */
  // ! doUpload調用接口。調用doc接口上传pdf返回docId
  @action createUploadTask = (fileData, taskType, callback, error, onUploadCallback) => {
    let _this = this;
    let task = new Task({ fileData }, async (data) => {
      _this.currentTask = task;
      onUploadCallback && onUploadCallback({percent:0, task})
      //this.onUpdateTaskMessage({ status: TASK_STATUS.BEGIN_UPLOAD, ret: 0 }, taskType);
      const {fileData} = data;
      const result = await convertService.doUpload(fileData, (percent)=>{
        onUploadCallback && onUploadCallback({percent, task})
      }, (/* source */)=>{
        task.setCancelSource({cancel:callback});
      }).catch((err) => {
        console['log']('TCL: TaskStore -> @action createUploadTask -> err', err);
        return err;
      });
      
//      _this.currentTask = null;
      _this.isUploading = false;

      if (result && result.ret == 0) {
        callback && callback(result);
        _this.doNextTask();
        return;
      }
      _this.doNextTask();
      if(axios.isCancel(result)){
        console['log']("TCL: @actioncreateUploadTask -> cancel this.currentTask, result", task, result)
        return;
      }
      error && error(result);
    });
    
    return task;
  };

  @action  createConvertTask (fileList, taskType, cfg, callback, error) {
    let _this=this;
    let task = new Task({ fileList, taskType, cfg }, ({ fileList, taskType, cfg }) => {
      convertService.doConvert( fileList, taskType, cfg, async (result) => {
        // _this.currentTask = null;
        _this.isUploading = false;
          if (result.ret != 0) {

            
            error && error(result);
            return;
          }


          callback && callback(result);
          // const { isRunFormRecognition } = store.docStore.formPreference;
          // if(isRunFormRecognition){
          //   let doc =  await window.pdfui.getCurrentPDFDoc();
          //   !!doc && store.docStore.setAutoRecognitionForm()
          // }
        }, (err) => {
          
          // _this.currentTask = null;
          _this.isUploading = false;
          error && error(err);
        },
      );
    });
    return task;
  }
  @action addToTaskList(task) {
    this.tasks.push(task)
  }

  /**
   *
   *
   * @param {Task} task
   * @param {Boolean} isMultiFile
   * @returns {Number} The id of Task
   */
  @action doAddToTaskList = (task, /* isMultiFile */) => {
    //let hash = this.index++;
    //task.id = hash;

    this.tasks.push(task);
    //isMultiFile && (this.taskFileList.push(task));
    // start
    this.doNextTask();
    return task;
  };

  @action doNextTask = () => {
    if (this.isUploading) {
      return;
    }
    // get next task
    let task = this.popNextTask();
    if (!task) {
      this.isUploading = false;
      this.tasksFinishCallback && this.tasksFinishCallback()
      // TODO notice ui
      return;
    }
    this.currentTask = task;
    this.isUploading = true;
    task.start && task.start();
  };

  /**
   *
   * @returns {Task}
   * @memberof TaskStore
   */
  @action popNextTask = () => {
    if (this.tasks.length === 0) {
      return null;
    }
    let task = this.tasks.shift();
    return task;
  };


  /**
   *
   * @param {Number} seq
   * @param {Task[]} arr
   * @returns {Task[]}
   */
  remove(seq, arr){
    /**
     * @param {Task} item
     * @returns
     */
    let index = arr.findIndex((item) => {
      if (item.id === seq) {
        return true;
      }
      return false;
    });
    let list = null;
    if (index !== -1) {
      list = arr.splice(index, 1);
    }
    return list;
  };

  @action pause = () => {};

  @action getByKey = (key) => {
    let val = this.tasks.get(key);
    return val;
  };

  // be used for file to pdf
  @action getTaskTypeByFileName(fileName) {
    let docType = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
    switch (docType) {
    case 'htm':
    case 'html':
    case 'shtml':
        return CONVERT_TYPE.HTML2PDF;
      case 'jpg':
      case 'jpe':
      case 'jpeg':
      case 'bmp':
      case 'dib':
      case 'png':
      case 'gif':
      case 'tiff':
      case 'jpx':
      case 'tif':
        return CONVERT_TYPE.IMGTOPDF;
      case 'ppt':
      case 'pptx':
      case 'pot':
      case 'potx':
      case 'pptm':
      case 'ppsx':
      case 'ppsm':
      case 'potm':
        return CONVERT_TYPE.PPTTOPDF;
      case 'doc':
      case 'docx':
      case 'rtf':
      case 'dot':
      case 'dotx':
      case 'docm':
      case 'dotm':
      case 'wpd':
      case 'vsd':
      case 'vsdx':
      case 'wps':
      case 'hwp':
        return CONVERT_TYPE.WORDTOPDF;
      case 'xls':
      case 'xlsx':
      case 'xlt':
      case 'xltx':
      case 'xlsm':
      case 'xlsb':
      case 'xltm':
      case 'csv':
        return CONVERT_TYPE.EXCELTOPDF;
      case 'txt':
      case 'text':
         return CONVERT_TYPE.TXT2PDF;
      default:
        return CONVERT_TYPE.UNKNOWN;
    }
    
  }
}

export default TaskStore;